module.exports = __webpack_public_path__ + "9c30977367c50027ab25503affa2d580.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/vercetti.jpg
// module id = 873
// module chunks = 0